export enum TipoEtapaCaptacaoEnum{
  PREENCHIMENTO = "Preenchimento",
  REDIRECIONAMENTO = "Redirecionamento"
}
